import React, { useCallback } from 'react';
import { AdminServiceEvents, ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export const useSendWelcomeEmail = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const sendWelcomeEmail = useCallback(
        async (userId: number, options: ApiRequestOptionsType) => {
            try {
                await services.api.call(
                    {
                        method: 'post',
                        url: `/api/users/${userId}/welcome`,
                    },
                    options
                );

                // No response, return organizationUserId
                services.events.publish(events.welcome_email_sent, userId);
                return userId;
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api, services.events, events.welcome_email_sent]
    );

    return sendWelcomeEmail;
};
